import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import useApp from '@/hooks/use-app.hook';
import { getBreakpoint } from '@/theme';
import useAppTheme from '@/hooks/use-app-theme.hooks';

const useStyles = createUseStyles({
  orgLogo: {
    display: 'block',
    maxWidth: 250,
    maxHeight: 30,
    width: 'auto',
    height: 'auto',
  },
  [getBreakpoint('md')]: {
    orgLogo: {
      maxHeight: 24,
    },
  },
});

const OrgLogo: FC = () => {
  const styles = useStyles();
  const { branding } = useApp();
  const { colorMode } = useAppTheme();

  const { orgName = '', lightThemeLogo, darkThemeLogo } = branding;
  const themeLogo = colorMode === 'dark' ? darkThemeLogo : lightThemeLogo;
  const hasLogo = !!themeLogo;

  if (!hasLogo) {
    return null;
  }

  return <img src={themeLogo} alt={orgName} className={styles.orgLogo} />;
};

export default OrgLogo;
